import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, X } from 'lucide-react';
import { usePostingStore } from '../../lib/store/usePostingStore';

const steps = [
  { number: 1, title: 'Media & Platforms' },
  { number: 2, title: 'Media Options' },
  { number: 3, title: 'Captions & AI' },
  { number: 4, title: 'Schedule' },
  { number: 5, title: 'Review & Publish' }
];

const ProgressHeader: React.FC = () => {
  const { currentStep, goToStep } = usePostingStore();

  return (
    <div className="mb-8">
      <ol className="grid grid-cols-5 gap-4 mb-8 px-4">
        {steps.map((step) => (
          <li
            key={step.number}
            className="flex flex-col items-center space-y-2"
          >
            <motion.div
              layout
              className={`flex items-center justify-center h-11 min-w-24 px-4 py-2 rounded-full text-sm font-medium ${
                currentStep === step.number
                  ? 'bg-primary text-white shadow-lg shadow-primary/20'
                  : currentStep > step.number
                  ? 'bg-primary/10 text-primary'
                  : 'bg-background/10 text-gray-500 dark:text-gray-400'
              }`}
              onClick={() => currentStep >= step.number && goToStep(step.number)}
              style={{ cursor: currentStep >= step.number ? 'pointer' : 'not-allowed' }}
            >
              <AnimatePresence mode="wait">
                {currentStep > step.number ? (
                  <motion.div
                    key="check"
                    initial={{ opacity: 0, scale: 0.5 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.5 }}
                    className="inset-1"
                  >
                    <Check className="h-4 w-4" />
                  </motion.div>
                ) : (
                  <motion.div
                    key="number"
                    initial={{ opacity: 0, scale: 0.5 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.5 }}
                    className="inset-1"
                  >
                    {step.number}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
            <span className="text-xs font-medium text-gray-500 dark:text-gray-400 xs:hidden sm:block">
              {step.title}
            </span>
          </li>
        ))}
      </ol>

      {/* Mobile version */}
      <div className="sm:hidden mt-4">
        <div className="flex items-center justify-between mb-4">
          <span className="text-sm font-medium text-gray-900 dark:text-white">
            Step {currentStep} of {steps.length}
          </span>
          <span className="text-sm font-medium text-indigo-600 dark:text-indigo-400">
            {steps[currentStep - 1].title}
          </span>
        </div>
        <div className="overflow-hidden rounded-full bg-gray-200 dark:bg-dark-700">
          <motion.div 
            className="h-2 rounded-full bg-indigo-600"
            initial={{ width: `${((currentStep - 1) / (steps.length - 1)) * 100}%` }}
            animate={{ width: `${((currentStep - 1) / (steps.length - 1)) * 100}%` }}
            transition={{ duration: 0.3 }}
          />
        </div>
      </div>
    </div>
  );
};

export default ProgressHeader;